import type { Scenario } from "@reco/shared/src/constants";
import { computed, toValue, type MaybeRefOrGetter } from "vue";
import { useI18n } from "vue-i18n";

export type UseSubheadingParams = {
  scenario: Scenario;
  subheadingProp?: string;
};

/**
 * Get the subheading for the component based on scenario and prop
 * @param paramsOrGetter - The parameters for the subheading, or a getter function returning them
 * @returns The subheading as a computed ref
 */
export function useSubheading(paramsOrGetter: MaybeRefOrGetter<UseSubheadingParams>) {
  const { t, te } = useI18n();

  return computed(() => {
    const { scenario, subheadingProp } = toValue(paramsOrGetter);

    if (subheadingProp) {
      return subheadingProp;
    }
    if (te(`reco-frontend-next.Slider.${scenario}.subheading`)) {
      return t(`reco-frontend-next.Slider.${scenario}.subheading`);
    }

    return "";
  });
}
